import { createContext, useContext, useEffect, useState } from "react";
import { useQuoteController } from "./QuoteControllerContext";

interface ProgressBarContextType {
    completedSteps: number;
    totalSteps: number;

    isProgressBarVisible: boolean;
    setProgressBarVisible: (isVisible: boolean) => void;
    incrementProgress: () => void;
    decrementProgress: () => void;
}

const ProgressBarContext = createContext<ProgressBarContextType | undefined>(undefined);

export const ProgressBarContextProvider = ({ children }) => {
    const { pageState } = useQuoteController();

    const [completedSteps, setCompletedSteps] = useState(0);
    const [totalSteps, setTotalSteps] = useState(0)
    const [isProgressBarVisible, setIsProgressBarVisible] = useState(false);


    useEffect(() => {
        setCompletedSteps(pageState.completedSteps);
        setTotalSteps(pageState.totalSteps);

        let visible = true;
        if (!pageState.name || pageState.name === "Splashscreen")
            visible = false;

        setIsProgressBarVisible(visible);
    }, [pageState]);

    const value: ProgressBarContextType = {
        completedSteps: completedSteps,
        totalSteps: totalSteps,
        isProgressBarVisible: isProgressBarVisible,

        setProgressBarVisible: (isVisible: boolean) => {
            setIsProgressBarVisible(isVisible);
        },

        incrementProgress: () => {
            setCompletedSteps(prev => prev + 1);
        },

        decrementProgress: () => {
            setCompletedSteps(prev => prev - 1);
        }
    }

    return (
        <ProgressBarContext.Provider value={value}>
            {children}
        </ProgressBarContext.Provider>
    )
}

export const useProgressBarContext = ():
    | ProgressBarContextType
    | undefined => {
    return useContext(ProgressBarContext);
};


